// wijmo
/* eslint-disable react-hooks/exhaustive-deps */
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import dayjs from "dayjs"
import queryString from "query-string"
import { useEffect, useRef, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import NumberInput from "../../../components/InputWrapper/NumberInput"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import { RootState } from "../../../globalStore/rootreducer"
import ZyomuinbetuNenpiService from "../../../service/truckcontrol/zyomuinbetunenpi/zyomuinbetuNenpiService"
import {
  TZyomuinbetuNenpiGetListReq,
  TZyomuinbetuNenpiGetListRes,
  TZyomuinSyaryoInfo,
} from "../../../service/truckcontrol/zyomuinbetunenpi/TZyomuinbetuNenpi"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import BusyoService from "../../../service/master/busyo/busyoService"
import stringUtil from "../../../ts/util/stringUtil"
import CheckInput from "../../../components/InputWrapper/CheckInput"
// import TenkenSeibiModal from "./TenkenseibiModal"

type TGridItem = TZyomuinSyaryoInfo & {}

/**
 * 乗務員別 燃費一覧
 * @returns
 */
const ZyomuinbetuNenpiList = () => {
  const history = useHistory()
  const location = useLocation()
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)
  const 営業年 = dayjs(eigyobi).year()

  // ref
  const ref明細フォーマットフラグ = useRef<boolean>(false)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  // 一旦4月から固定
  const 表示年月List: number[] = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3]

  //TODO:ページ名称確定必須
  let gridId = "ZyomuinbetuNenpiList_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: TZyomuinbetuNenpiGetListRes | null,
    pageSize: number
  ) => {
    const newList: TGridItem[] = []
    if (data != null) {
      data.乗務員車両情報List.forEach((item) => newList.push(item))
    }
    return new wjCore.CollectionView<TGridItem>(newList, {
      pageSize,

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })
  }

  // TODO:検索前に必須チェック
  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TZyomuinbetuNenpiGetListReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に
    flexGrid?.select(-1, -1) // カレンダー部分のselectEvent回避の為のおまじない

    let currentSearchCondition: TZyomuinbetuNenpiGetListReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new ZyomuinbetuNenpiService().getList(
        currentSearchCondition
      )
      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
      flexGrid?.refresh()
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: { 検索年度?: string; 部所コード?: string } = queryString.parse(
      location.search
    )
    const query検索年度 = stringUtil.isNullOrWhiteSpace(query.検索年度)
      ? 営業年
      : parseInt(query.検索年度!)
    set検索年度(query検索年度)
    set部所コード(query.部所コード ?? "")

    return {
      検索年度: query検索年度,
      部所コード: query.部所コード ?? "",
    } as TZyomuinbetuNenpiGetListReq
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TZyomuinbetuNenpiGetListReq => {
    return {
      検索年度: 検索年度 ? 検索年度 : dayjs(eigyobi).year(),
      部所コード: 部所コード ?? "",
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TZyomuinbetuNenpiGetListReq
  ) => {
    const disp部所 = 部所ItemSource?.find(
      (i) => i.部所コード === searchCondition.部所コード
    )
    return {
      年: searchCondition.検索年度,
      部所: disp部所
        ? `${disp部所.部所コード} ${disp部所.部所略称}`
        : undefined,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView(null, pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    set明細表示フラグ(0)
    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
    // AlertClear
    dispatch(clearAlert())
  }

  const clearSearchState = () => {
    set検索年度(営業年)
    ref明細フォーマットフラグ.current = false

    set部所コード("")
    set部所(undefined)
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    // ヘッダーに行追加
    // header行に一行追加
    // 追加行のみ初期化時に設定
    let extraRow = new wjcGrid.Row()
    extraRow.allowMerging = true
    let columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)
    columnHeaders.columns.forEach((c, index) => {
      if (c.binding != null) {
        const binding = c.binding as keyof TGridItem
        let setHeaderText = ""
        if (binding.startsWith("部所")) {
          setHeaderText = "部所"
        } else if (binding.startsWith("社員")) {
          setHeaderText = "乗務員"
        } else if (binding.startsWith("車番")) {
          setHeaderText = "車番"
        } else if (binding.startsWith("年平均")) {
          setHeaderText = "年平均"
        } else if (binding.includes("10月")) {
          setHeaderText = "10月"
        } else if (binding.includes("11月")) {
          setHeaderText = "11月"
        } else if (binding.includes("12月")) {
          setHeaderText = "12月"
        } else if (binding.includes("1月")) {
          setHeaderText = "1月"
        } else if (binding.includes("2月")) {
          setHeaderText = "2月"
        } else if (binding.includes("3月")) {
          setHeaderText = "3月"
        } else if (binding.includes("4月")) {
          setHeaderText = "4月"
        } else if (binding.includes("5月")) {
          setHeaderText = "5月"
        } else if (binding.includes("6月")) {
          setHeaderText = "6月"
        } else if (binding.includes("7月")) {
          setHeaderText = "7月"
        } else if (binding.includes("8月")) {
          setHeaderText = "8月"
        } else if (binding.includes("9月")) {
          setHeaderText = "9月"
        } else {
          setHeaderText = c.header ?? ""
        }
        c.allowMerging = true
        columnHeaders.setCellData(0, index, setHeaderText)
      }
    })

    // ヘッダの設定
    grid.formatItem.addHandler(formatItem)
    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    // ループをフラグで制御？
    if (ref明細フォーマットフラグ.current) return

    // 背景色設定
    if (e.panel === f.cells) {
      const rowData: TZyomuinbetuNenpiGetListRes = e.getRow().dataItem
      if (!rowData) return
    }
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView(null, pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]

  const [検索年度, set検索年度] = useState<number>(営業年)
  const [明細表示フラグ, set明細表示フラグ] = useState(0)

  //#region comboboxState
  // 部所
  const [部所コード, set部所コード] = useState<string | null>()
  const [, set部所] = useState<T部所マスタ | null>()
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    T部所マスタ["部所コード"],
    T部所マスタ
  > | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)
  //#endregion

  //#endregion

  //#region [effect]
  useEffect(() => {
    document.title = `乗務員別 燃費一覧`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])

  // TODO: APIから取得する
  useEffect(() => {
    Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
      set部所ItemSource(部所ListRes.data.filter((b) => b.運行部所フラグ === 1))
      // 初期値としてシステム年を設定
      set検索年度(営業年)
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && 部所IsLoadEnded) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized, 部所IsLoadEnded])

  //#endregion
  const createカレンダー列 = (
    itemName: "燃費" | "走行距離" | "給油量",
    month: number
  ) => {
    return (
      <wjrGrid.FlexGridColumn
        key={`${itemName}_${month}月`}
        binding={`${itemName}_${month}月`}
        width={itemName === "燃費" ? 70 : 85}
        align="center"
        visible={itemName === "燃費" ? true : 明細表示フラグ === 1}
        header={`${itemName}`}
        format={"N2"}
        cssClass="align-end"></wjrGrid.FlexGridColumn>
    )
  }

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">乗務員別 燃費一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-70rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <ul className="list-cmn">
                          <li className="list-cmn list-padding d-flex">
                            <div>
                              <NumberInput
                                id="年"
                                name="年"
                                min={1900}
                                max={9999}
                                step={1}
                                required
                                value={検索年度}
                                setValue={(v) => {
                                  set検索年度(v)
                                }}
                                placeholder="年"></NumberInput>
                            </div>
                            <div className="list-padding">
                              <ComboBox.Busyo
                                placeholder="部所"
                                isAllSelect={true}
                                itemsSource={部所ItemSource}
                                isLoadEnded={部所IsLoadEnded}
                                setIsLoadEnded={set部所IsLoadEnded}
                                setSelectedValue={set部所コード}
                                selectedValue={部所コード}
                                setSelectedItem={set部所}
                                ComboBox={部所ComboBox}
                                setComboBox={set部所ComboBox}></ComboBox.Busyo>
                            </div>
                          </li>
                        </ul>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="text-end">
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            search()
                          }}>
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                gridProperties={{
                  allowSorting: wjcGrid.AllowSorting.None,
                  allowDragging: wjcGrid.AllowDragging.None,
                  itemFormatter: (
                    panel: wjcGrid.GridPanel,
                    r: number,
                    c: number,
                    cell: HTMLElement
                  ) => {
                    if (panel.cellType === wjcGrid.CellType.ColumnHeader) {
                      cell.style.textAlign = "center"
                    }
                  },
                }}
                headerComponent={
                  <CheckInput
                    id="明細表示"
                    type={"switch"}
                    label={"走行距離・給油量を表示"}
                    setValue={(v) => set明細表示フラグ(v)}
                    value={明細表示フラグ}
                  />
                }>
                <wjrGrid.FlexGridColumn
                  binding="部所略称"
                  width={110}
                  header="部所"
                  cssClass="align-left"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="社員コード"
                  width={90}
                  header="社員CD"
                  cssClass="align-left"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="社員氏名"
                  width={110}
                  header="氏名"
                  cssClass="align-left"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="車番"
                  width={70}
                  header="車番"
                  cssClass="align-left"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="年平均"
                  width={80}
                  format="N2"
                  header="年平均"
                  cssClass="align-end"></wjrGrid.FlexGridColumn>

                {/* カレンダー列 */}
                {表示年月List
                  .map((month) => [
                    createカレンダー列("燃費", month),
                    createカレンダー列("走行距離", month),
                    createカレンダー列("給油量", month),
                  ])
                  .map((node) => node)}
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default ZyomuinbetuNenpiList
